import { render, staticRenderFns } from "./TopProducts.vue?vue&type=template&id=54ffb900"
import script from "./TopProducts.vue?vue&type=script&lang=js"
export * from "./TopProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProduct: require('/home/korzinka/www/front/components/base/Product.vue').default})
